export function formatGopSize(gopSizeMs: number) {
  if (gopSizeMs > 5000) {
    return `${gopSizeMs / 1000}s`
  }

  return `${gopSizeMs} ms`
}
